import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/Plugins/TableSorter/jquery.tablesorter";
import { AttachmentsView, AttachmentsViewOptions } from "core/classes/attachments/attachments.view.class";

class TableFullscreen extends Class {
    constructor(element) {
        super();
        this.element = $(element);
        this.table = this.element.find("table");
        this.wrapTable();
        this.createTableOverlay();
        this.appendButtonAndCaptionToTableHeader();
        this.showFullScreenButton();
        this.setUpEvents();
        this.$overlay = $(".tableOverlay");
    }

    setUpEvents() {
        var self = this;
        $("body").on("click", ".tableOverlay .close", evt => {
            evt.preventDefault();
            this.closeOverlay();
        });

        $("body").on("keyup", ".tableOverlay .close", e => {
            if (e.which == 27) {
                self.closeOverlay();
            }
        });

        $(this.element).on("click", ".fsButton", evt => {
            this.tableSetup();
        });

        $(this.element).on("keyup", ".fsButton", e => {
            if (e.which == 13) {
                this.tableSetup();
            }
        });
        $(window).on('resize', evt => {
            this.showFullScreenButton();
        })
    }

    closeOverlay() {
        // $(this.table).stickyTableHeaders("destroy");
        this.$overlay.removeClass("open");
        this.$overlay.find(".overlayTableWrapper").remove();
        this.$overlay.find(".overlayHeader").remove();
        this.table.tableHeadFixer({ head: false, left: 0 });
        $("body").removeClass("disabled-scroll");
    }

    tableSetup() {
        this.table
            .clone()
            .appendTo(".tableOverlay")
            .wrap(`<div class='overlayTableWrapper'></div>`);
        this.openTableOverlay();
    }

    wrapTable() {
        $(this.table).wrap(`<div class='table-wrapper'></div>`);
        this.makeTableHeader();
    }

    makeTableHeader() {
        $(this.element).prepend(
            `<div class='table-header'><div class='fsButton' tabindex='0'><span>Full screen</span><i></i></div><div class='table-header-sleeve'></div></div>`
        );
    }

    createTableOverlay() {
        if (!$("body").find(".tableOverlay").length) {
            $("body").append(`<div class='tableOverlay'></div>`);
        }
    }

    showFullScreenButton() {
        $('.storytext .table-full').each(function(i, item) {
            var $self = $(this);
            var wrapperWidth = $self.find('.table-wrapper').innerWidth();
            var tableWidth = $self.find('.datatable').innerWidth();
            var fullScreenButton = $self.find('.fsButton');
            if (tableWidth <= wrapperWidth) {
                fullScreenButton.css('display', 'none')
            } else {
                fullScreenButton.css('display', 'block')
            }
        })
    }

    appendButtonAndCaptionToTableHeader() {
        if ($(this.table).find("caption").length > 0) {
            this.element
                .find(".table-header-sleeve")
                .prepend(`<div class='header'>${this.table.find("caption")[0].innerText}</div>`);
        } else {
            this.element.find(".table-header-sleeve").prepend(`<div class='header'></div>`);
        }
    }

    openTableOverlay() {
        var self = $(this);

        this.$overlay.addClass("open");
        $("body")
            .find(".tableOverlay")
            .prepend(
                `<div class='overlayHeader'><div class='headerCaption'>${this.table.find("caption").text()}</div><span class='close' tabindex='0'><span>Close table</span><i></i></span></div>`
            );
        $("body")
            .find(".tableOverlay .close")
            .focus();
        $("body").addClass("disabled-scroll");
        this.makeTablesSortable();
        $("window").trigger("abacus:fullscreen:loaded");

        this.checkHeaders();
    }

    checkHeaders() {
        if ($(this.table).find("thead th").length && $(this.table).find("tbody th").length) {
            $(".tableOverlay table").tableHeadFixer({ head: true, left: 1 });
        } else if ($(this.table).find("thead th").length && $(this.table).find("tbody th").length == 0) {
            $(".tableOverlay table").tableHeadFixer({ head: true });
        } else if ($(this.table).find("thead th").length == 0 && $(this.table).find("tbody th").length) {
            $(".tableOverlay table").tableHeadFixer({ head: false, left: 1 });
        }
    }

    makeTablesSortable() {
        this.$overlay.find("table.sortable").each(function() {
            var self = $(this);
            setTimeout(function() {
                self.tablesorter();
            }, 0);
        });
    }
}

export { TableFullscreen };


// WEBPACK FOOTER //
// ./Javascript/core/classes/table.fullscreen.class.js